import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #d2d2d7;
  color: #1d1d1f;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  width: ${(props) => props.width || "300"}px;
  height: ${(props) => props.height || "44"}px;
  transition: all 0.15s;
  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;

const Button = (props) => <StyledButton {...props} />;

export default Button;